import { NavBar } from "../../components/NavBar";
import { useCompany } from "../../hooks/useCompany";
import { DistrictProvider } from "../../providers/DistrictProvider";
import { DeliveryDistrictPage } from "../DeliveryDistrict/index";
import { MapPage } from './components/Maps'
import { api } from "../../api/api";
import { Toast } from "../../utils/Toast";
import { useNavigate } from "react-router-dom";

import { FiDollarSign, FiHelpCircle, FiMap, FiMapPin, FiNavigation, FiSave, FiTag, FiTruck } from "react-icons/fi";
import { mascaraMoeda, maskCurrency } from "../../utils/utils";
import { useEffect, useState } from "react";
import './style.css'

export function MethodDelivery() {
  const navigate = useNavigate()
  const { configurations, updateConfiguration } = useCompany()

  const [discount, setDiscount] = useState({
    active: false,
    pricingDiscount: 0,
    minPrincingOrder: 0,
    typeDiscount: null
  })

  async function saveDiscoutnDelivery(data) {
    if (
      discount.active === true &&
      (discount.minPrincingOrder === 0 ||
        discount.pricingDiscount === 0 ||
        discount.typeDiscount === null)
    ) {
      return Toast.warning('Todos campos são obrigatórios')
    }

    await api.post('/configurations', {
      discountDelivery: JSON.stringify({
        active: data.active,
        discounts: [data]
      })
    })

    Toast.success('Configurações salva.')
  }

  async function setMethodDeliveryOfConfiguration(methodDelivery) {
    if (methodDelivery === 'district') {
      updateConfiguration({ methodDelivery })
      await api.post('/configurations', { methodDelivery })
        .catch(() => window.location.reload())
    }

    if (methodDelivery === 'maps') {
      updateConfiguration({ methodDelivery })
      await api.post('/configurations', { methodDelivery })
        .catch(() => window.location.reload())
    }

    return Toast.success('Alterado método de entrega!')
  }

  useEffect(() => {
    setDiscount({
      active: configurations?.discountDelivery?.active,
      pricingDiscount: configurations?.discountDelivery?.discounts[0]?.pricingDiscount || 0,
      minPrincingOrder: configurations?.discountDelivery?.discounts[0]?.minPrincingOrder || 0,
      typeDiscount: 'valor_fixo',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configurations.id])

  return (
    <NavBar>
      <main className="delivery-page">
        <header className="delivery-page-header">
          <div>
            <h1>Métodos de entrega</h1>
            <p>Configure taxas, áreas atendidas e cálculo de distância</p>
          </div>
          <button type="button" className="delivery-help-button" onClick={() => Toast.message('Dúvidas', 'Configure descontos, valores para entregadores e como a taxa de entrega será calculada.')}>
            <FiHelpCircle size={17} /> Ajuda
          </button>
        </header>

        <section className="delivery-settings-grid">
          <article className="delivery-setting-card">
            <div className="delivery-card-heading">
              <span><FiTag size={18} /></span>
              <div><h2>Desconto na entrega</h2><p>Ofereça desconto na taxa conforme o valor do pedido</p></div>
              <label className="delivery-switch">
                <input checked={Boolean(discount.active)} onChange={(event) => {
                  const nextDiscount = { ...discount, active: event.target.checked }
                  setDiscount(nextDiscount)
                  saveDiscoutnDelivery(nextDiscount)
                }} type="checkbox" />
                <span />
              </label>
            </div>

            <div className={`delivery-setting-content ${!discount.active ? 'disabled' : ''}`}>
              <label><span>Pedido mínimo</span><input type="text" disabled={!discount.active} value={maskCurrency(discount.minPrincingOrder)} onChange={(event) => setDiscount({ ...discount, minPrincingOrder: mascaraMoeda(event.target.value) })} /></label>
              <label><span>Valor do desconto</span><input type="text" disabled={!discount.active} value={maskCurrency(discount.pricingDiscount)} onChange={(event) => setDiscount({ ...discount, pricingDiscount: mascaraMoeda(event.target.value) })} /></label>
              <button type="button" disabled={!discount.active} onClick={() => saveDiscoutnDelivery(discount)}><FiSave size={15} /> Salvar desconto</button>
            </div>
          </article>

          <article className="delivery-setting-card">
            <div className="delivery-card-heading">
              <span><FiDollarSign size={18} /></span>
              <div><h2>Valor do entregador</h2><p>Valor fixo repassado ao motoboy por entrega</p></div>
            </div>
            <div className="delivery-setting-content single-setting">
              <label><span>Valor por entrega</span><input type="text" value={maskCurrency(configurations.pricingDefaultDeliveryMotoboy)} onChange={(event) => updateConfiguration({ pricingDefaultDeliveryMotoboy: mascaraMoeda(event.target.value) })} /></label>
              <button type="button" onClick={async () => {
                await api.post('/configurations', { pricingDefaultDeliveryMotoboy: configurations.pricingDefaultDeliveryMotoboy })
                  .then(() => Toast.success('Valor de entrega atualizado com sucesso!'))
                  .catch(() => Toast.error('Erro ao atualizar valor de entrega!'))
              }}><FiSave size={15} /> Salvar valor</button>
            </div>
          </article>
        </section>

        <section className="delivery-method-section">
          <div className="delivery-section-heading">
            <span><FiTruck size={19} /></span>
            <div><h2>Como calcular a entrega?</h2><p>Selecione apenas um método para utilizar no cardápio</p></div>
          </div>

          <div className="delivery-method-options">
            <button type="button" className={configurations.methodDelivery === 'district' ? 'active' : ''} onClick={() => setMethodDeliveryOfConfiguration('district')}>
              <span className="method-icon"><FiMapPin size={21} /></span>
              <div><strong>Por bairros</strong><small>Cadastre cada bairro e defina sua taxa</small></div>
              <span className="method-status">{configurations.methodDelivery === 'district' ? 'Ativo' : 'Selecionar'}</span>
            </button>
            <button type="button" className={configurations.methodDelivery === 'maps' ? 'active' : ''} onClick={() => setMethodDeliveryOfConfiguration('maps')}>
              <span className="method-icon"><FiMap size={21} /></span>
              <div><strong>Por distância</strong><small>Calcule o valor usando faixas de quilômetros</small></div>
              <span className="method-status">{configurations.methodDelivery === 'maps' ? 'Ativo' : 'Selecionar'}</span>
            </button>
          </div>

          <div className="delivery-method-content">
            {configurations.methodDelivery === 'district' && <DistrictProvider><DeliveryDistrictPage /></DistrictProvider>}
            {configurations.methodDelivery === 'maps' && configurations.googleKey && <MapPage />}
            {!configurations.googleKey && configurations.methodDelivery === 'maps' && (
              <div className="delivery-maps-empty">
                <span><FiNavigation size={26} /></span>
                <h3>Google Maps ainda não configurado</h3>
                <p>Adicione as credenciais da integração para calcular entregas por distância.</p>
                <button type="button" onClick={() => navigate('/integration')}>Configurar integração</button>
              </div>
            )}
          </div>
        </section>
      </main>
    </NavBar>
  )
}
